import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Input, List, Label, Icon, Button, Message } from 'semantic-ui-react';
import i18next from 'i18next';

import API from '../../../../../../actions/api';
import AreaAdditionForm from '../../area-addition-form/AreaAdditionForm';

import './AreasPoolPane.scss';

class AreasPoolPane extends Component {
    defaultState = {
        areaTagToSearch: '',
        areasSearchResults: null,
        activeSearchResult: null,
        areasPoolSearchStatus: {
            loading: false,
            message: '',
            error: ''
        }
    };
    state = { ...this.defaultState };

    constructor(props) {
        super(props);

        this.resetAreasSearchResults = this.resetAreasSearchResults.bind(this);
        this.handleAreaNameChange = this.handleAreaNameChange.bind(this);
        this.handleAreasPoolSearch = this.handleAreasPoolSearch.bind(this);
        this.handleAreaChoice = this.handleAreaChoice.bind(this);
        this.isEligbleForSubmition = this.isEligbleForSubmition.bind(this);
    }

    resetAreasSearchResults(override) {
        const { areaTagToSearch, ...rest } = this.defaultState;
        this.setState({ ...rest, ...override });
    }

    handleAreaNameChange(event, { value }) {
        this.setState({
            areaTagToSearch: value
        });
    }

    isEligbleForSubmition() {
        return this.state.activeSearchResult !== null;
    }

    handleAreasPoolSearch(event) {
        this.props.clearDrawnDeliveryZonesFromMap();
        this.resetAreasSearchResults({ areasPoolSearchStatus: { ...this.state.areasPoolSearchStatus, ...{ loading: true } } });

        API.deliveryAreasPool.search(this.state.areaTagToSearch)
            .then(({ data }) => {
                let message = data.length === 0 ? this.i18next.t('deliveryAreasNotFound') : '';

                this.setState({
                    areasSearchResults: data,
                    activeSearchResult: null,
                    areasPoolSearchStatus: { ...this.state.areasPoolSearchStatus, ...{ error: '', message, loading: false } }
                });
            }).catch(err => {
                this.setState({
                    areasPoolSearchStatus: {
                        ...this.state.areasPoolSearchStatus, ...{
                            error: err.toString(),
                            message: '',
                            loading: false
                        }
                    }
                });
            });
    }

    handleAreaChoice(area, resultIndex) {
        this.props.clearDrawnDeliveryZonesFromMap();
        this.setState({ activeSearchResult: resultIndex });

        setImmediate(() => {
            area.zones.forEach(zone => {
                this.props.drawDeliveryZonesOnMap(zone.boundaries, '#40E0D0');
            });
        });
    }

    renderSearchResults() {
        return this.state.areasSearchResults.map((result, index) => {
            return (
                <List.Item key={result.tag + index}
                    className={index === this.state.activeSearchResult ? 'pi-areas-pool-search-result-active' : null}
                    onClick={() => this.handleAreaChoice(result, index)}>
                    <List.Content floated='right'>
                        <Button primary basic >{i18next.t('choose')}</Button>
                    </List.Content>
                    <List.Icon name='world' size='large' verticalAlign='middle' />
                    <List.Content>
                        <List.Header>{result.tag}</List.Header>
                    </List.Content>
                </List.Item>
            );
        });
    }

    render() {
        const { addNewDeliveryAreas } = this.props;

        return (
            <Grid padded>
                <Grid.Row>
                    <Grid.Column width={13}>
                        <Input
                            action={<Button primary content={i18next.t('search')} onClick={this.handleAreasPoolSearch} />}
                            icon='search'
                            iconPosition='left'
                            placeholder={i18next.t('tag')}
                            loading={this.state.areasPoolSearchStatus.loading}
                            value={this.state.areaTagToSearch}
                            onChange={this.handleAreaNameChange}
                        />
                    </Grid.Column>
                </Grid.Row>
                {this.state.areasSearchResults &&
                    <Grid.Row>
                        <Grid.Column>
                            <List selection relaxed='very' verticalAlign='middle'>
                                {this.renderSearchResults()}
                            </List>
                        </Grid.Column>
                    </Grid.Row>
                }
                {this.state.activeSearchResult !== null &&
                    <Grid.Row>
                        <Grid.Column>
                            <AreaAdditionForm
                                addNewDeliveryAreas={addNewDeliveryAreas}
                                isEligbleForSubmition={this.isEligbleForSubmition}
                                deliveryZones={this.state.areasSearchResults[this.state.activeSearchResult].zones}
                                addToPool={false}
                               
                            />
                        </Grid.Column>
                    </Grid.Row>
                }
                {this.state.areasPoolSearchStatus.message &&
                    <Grid.Row>
                        <Grid.Column>
                            <Message icon>
                                <Icon name='circle warning' />
                                <Message.Content>{this.state.areasPoolSearchStatus.message}</Message.Content>
                            </Message>
                        </Grid.Column>
                    </Grid.Row>
                }
                {this.state.areasPoolSearchStatus.error &&
                    <Grid.Row>
                        <Grid.Column>
                            <Message negative
                                icon='cancel'
                                header={i18next.t("areasPoolSearchFailed")}
                                content={this.state.areasPoolSearchStatus.error} />
                        </Grid.Column>
                    </Grid.Row>
                }
            </Grid>
        );
    }
}

AreasPoolPane.propTypes = {
    addNewDeliveryAreas: PropTypes.func,
    drawDeliveryZonesOnMap: PropTypes.func,
    clearDrawnDeliveryZonesFromMap: PropTypes.func,
    
};

export default AreasPoolPane;
